import { CustomMainContent } from "../../components";
import { useState } from "react";
import { HelpButtons } from "./templates/HelpButtonsLearning";
import { PrincipalHeader } from "./templates/PrincipalHeader";
import { MainContentUsersTable } from "./templates/MainContentUsersTable";

// const options = [
//     { key: 1, value: "General" },
//     { key: 2, value: "Capacitacion1" },
//     { key: 3, value: "Capacitacion2" },
//     { key: 4, value: "Capacitacion3" },
//     { key: 5, value: "Capacitacion4" },
// ];

const LearningAbleUsers = () => {
    const [hasFilter, setHasFilter] = useState(false);
    const [dateRange, setDataRange] = useState(null);

    return (
        <CustomMainContent>
            <div className="flex h-full w-full min-w-[800px] ">
                <div className="w-100-68  h-full flex flex-col gap-4 ">
                    <div className="w-full h-14 shadow-md bg-white rounded-xl">
                        <PrincipalHeader
                            hasFilter={hasFilter}
                            setFilter={(value) => setHasFilter(value)}
                            dateRange={dateRange}
                            setDataRange={setDataRange}
                        />
                    </div>
                    <div className="w-full h-100-56   bg-white rounded-xl z-20 shadow-md">
                        <MainContentUsersTable></MainContentUsersTable>
                    </div>
                </div>
                <div className="w-[68px] h-full flex justify-center">
                    <HelpButtons />
                </div>
            </div>
        </CustomMainContent>
    );
};

export default LearningAbleUsers;
